module.exports = __webpack_public_path__ + "static/media/jam_coin-f.e99e1fe6.svg";